import { useEffect } from 'react'
import { brand } from '../brand'

/** Sets the document title and the robots directive per route. */
export default function Seo({ title, noindex = false }: { title?: string; noindex?: boolean }) {
  useEffect(() => {
    document.title = title ? `${title} · ${brand.name}` : brand.name
    let meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'robots'
      document.head.appendChild(meta)
    }
    meta.content = noindex ? 'noindex, nofollow' : 'index, follow'
  }, [title, noindex])
  return null
}
